module.exports = __WEBPACK_EXTERNAL_MODULE_826__;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 826
// module chunks = 9